import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { getToken } from "@/lib/api";
import { Toaster } from "sonner";
import { SidebarProvider, useSidebar } from "./SidebarContext";

function LayoutInner() {
  const { collapsed, hidden } = useSidebar();
  const leftPad = hidden ? "pl-8" : collapsed ? "pl-24" : "pl-72";
  return (
    <div className="min-h-screen bg-gray-50">
      <Toaster richColors position="top-right" />
      <Sidebar />
      <Header />
      <main
        className={`pt-20 pb-12 pr-8 min-h-screen min-w-0 overflow-x-hidden transition-[padding] duration-200 ${leftPad}`}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default function Layout() {
  if (!getToken()) return <Navigate to="/login" replace />;
  return (
    <SidebarProvider>
      <LayoutInner />
    </SidebarProvider>
  );
}
